import { combineReducers } from 'redux';
import mandatories from './mandatoriesReducer';
import budgets from './budgetReducer';
import lineItems from './lineItemReducer';
import estimates from './estimateReducer';

// Es6 shorthand property name looks like:
//	const rootReducer = combineReducers({
//		courses
//	});
// The root reducer defines what goes on within our state. 
// for example we'd access courses from state as state.courses
// Note that aliasing courseReducer to courses is a nice shorthand.
const rootReducer = combineReducers({
//	courses: courses, // Less terse but more clear, decidely not 'PRO'
//	authors, // compact way!!!
	mandatories,
	budgets,
	lineItems,
	estimates
});
export default rootReducer;

// THIS IS EASY TO FORGET!


// WEBPACK FOOTER //
// ./src/reducers/index.js